/**
 * Shared utilities for salary calculations.
 *
 * This module centralizes common functions and constants used across
 * the calculation modules to ensure consistency and reduce duplication.
 */

/**
 * Rounds a number to 2 decimal places.
 * Used for currency values throughout the calculation engine.
 *
 * @param {number} num - The number to round
 * @returns {number} The number rounded to 2 decimal places
 */
export const round2 = (num) => Math.round(num * 100) / 100;

/**
 * Multiplier for grossing up net pension contributions to gross.
 *
 * When a personal pension contribution is made net of basic rate tax relief,
 * the gross contribution is calculated by multiplying by 1.25 (100/80).
 *
 * Example: £100 net contribution = £125 gross contribution
 * (HMRC adds £25 basic rate relief to the pension pot)
 */
export const TAX_RELIEF_BASIC_RATE_MULTIPLIER = 1.25;

/**
 * Maximum salary supported by the calculator.
 * Used for input validation and UI constraints.
 */
export const MAX_SALARY = 200000;

/**
 * Minimum salary supported by the calculator.
 */
export const MIN_SALARY = 1;
